import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isLoadingGrades: false,
  isLoadingCursus: false,
  isLoadingImport: false,
  isLoadingAllStudents: false,
  isSuccess: false,
  isSuccessGrades: false,
  isSuccessCursus: false,
  isSuccessImport: false,
  isSuccessAllStudents: false,
  studentData: [],
  allStudentData: [],
  currentStudentData: [],
  cursusByStudentData: [],
  gradesByStudentData: [],
  gradesByCourseData: [],
  error: '',
  errorImport: '',
}

export const getCursusByStudent = createAsyncThunk(
  'student/getCursusByStudent',
  async ({ studentID }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/cursusByStudent`, {
        params: { MATRICULE: studentID },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const getGradesByStudent = createAsyncThunk(
  'student/getGradesByStudent',
  async ({ studentID }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/gradesByStudent`, {
        params: {
          MATRICULE: studentID,
        },
      })
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const updateChoiceByStudent = createAsyncThunk(
  'student/updateChoiceByStudent',
  async ({ MATRICULE, ID_SPE, choice, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res1 = await request(token).put(`/students/choiceByStudent`, {
        MATRICULE,
        ID_SPE,
        choice,
      })
      const message =
        lang === 'Français'
          ? 'Fiche de voeux sauvegardée avec succès'
          : 'Greeting card saved successfully'
      toast.success(message)
      const data = await res1.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCursusByStudent.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getCursusByStudent.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          cursusByStudentData: action.payload,
          error: '',
        }
      })
      .addCase(getCursusByStudent.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(getGradesByStudent.pending, (state) => {
        return {
          ...state,
          isLoadingGrades: true,
        }
      })
      .addCase(getGradesByStudent.fulfilled, (state, action) => {
        return {
          ...state,
          isLoadingGrades: false,
          //isSuccessGrades: true,
          gradesByStudentData: action.payload,
          error: '',
        }
      })
      .addCase(getGradesByStudent.rejected, (state, action) => {
        return {
          ...state,
          isLoadingGrades: false,
          //isSuccessGrades: false,
          error: action.error.message,
        }
      })
      .addCase(updateChoiceByStudent.pending, (state) => {
        return {
          //isLoadingGrade: true,
          ...state,
        }
      })
      .addCase(updateChoiceByStudent.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          //isLoadingGrade: false,
          error: '',
        }
      })
      .addCase(updateChoiceByStudent.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          //isLoadingGrade: false,
          error: action.error.message,
        }
      })
  },
})

export default studentSlice.reducer
